<!-- 告警配置：页头 + 4 个子页签（告警接收人 / 告警文案 / 监控州配置 / 配置变更日志） -->
<template>
  <div class="alert-config">
    <div class="page-header">
      <div class="ph-left">
        <h2 style="margin-top: 0;">
          <span>告警配置</span>
          <span class="h2-pt">Configuração de Alertas</span>
        </h2>
        <div class="desc">
          <span>配置飞书群组接收人、推送文案、纳入监控的州范围，并留痕配置变更</span>
          <span class="desc-pt">Configure destinatários de grupos Feishu, textos de alerta e o escopo de estados monitorados, com registro das alterações</span>
        </div>
      </div>
    </div>

    <el-tabs
      ref="tabs" :key="tabsKey" v-model="activeTab"
      class="alarm-configuration"
    >
      <el-tab-pane name="recipients">
        <template #label>
          <div class="cfg-tab">
            <div>告警接收人 / Destinatários de Alerta</div>
          </div>
        </template>
        <recipient-pane />
      </el-tab-pane>

      <el-tab-pane name="templates">
        <template #label>
          <div class="cfg-tab">
            <div>告警文案 / Modelos de Alerta</div>
          </div>
        </template>
        <template-pane />
      </el-tab-pane>

      <el-tab-pane name="states">
        <template #label>
          <div class="cfg-tab">
            <div>监控州配置 / Escopo de Estados</div>
          </div>
        </template>
        <monitor-state-pane />
      </el-tab-pane>

      <el-tab-pane name="configLog">
        <template #label>
          <div class="cfg-tab">
            <div>配置变更日志 / Log de Alterações</div>
          </div>
        </template>
        <config-log-pane />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RecipientPane from './RecipientPane';
import TemplatePane from './TemplatePane';
import MonitorStatePane from './MonitorStatePane';
import ConfigLogPane from './ConfigLogPane';

export default {
  name: 'AlertConfig',
  components: { RecipientPane, TemplatePane, MonitorStatePane, ConfigLogPane },
  data() {
    return {
      // 子页签：recipients 接收人 / templates 文案 / states 监控州（默认展示接收人）
      activeTab: 'recipients',
      // el-tabs 的 key：宽度测量异常时自增以强制重建（见 ensureActiveBar）
      tabsKey: 0,
      // 是否已经做过一次自检重建，避免反复重建
      barChecked: false
    };
  },
  mounted() {
    this.$nextTick(this.ensureActiveBar);
  },
  methods: {
    /**
     * 兜底自检：若 el-tabs 在隐藏容器中挂载，element 会把 active-bar 宽度测量成 0，
     * 表现为「初始没有下划线、切一次页签才出现」。这里检测到宽度为 0 就重建一次 el-tabs。
     */
    ensureActiveBar() {
      if (this.barChecked) return;
      this.barChecked = true;
      const bar = this.$refs.tabs && this.$refs.tabs.$el
        ? this.$refs.tabs.$el.querySelector('.el-tabs__active-bar')
        : null;
      if (bar && bar.getBoundingClientRect().width < 1) {
        this.tabsKey += 1;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.alert-config {
  padding: 4px 0 20px;
}
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;
}
.page-header h2 {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
}
.page-header h2 .h2-pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
  margin-top: 2px;
}
.page-header .desc {
  font-size: 12px;
  color: #86909c;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
}
.page-header .desc .desc-pt {
  font-size: 12px;
}

/* 子页签：与原型 .cfg-tab 一致（底部主色高亮） */
.cfg-tab {
  padding: 10px;
  line-height: 1.35;
  text-align: center;
}
/* 子页签样式一律写在 .alarm-configuration 作用域内（提高选择器特异性），
   避免被父级页面（顶层 el-tabs）的穿透样式覆盖 */
.alarm-configuration {
  ::v-deep .el-tabs__nav-wrap::after {
    height: 1px !important;
    background-color: #e5e6eb !important;
  }
  ::v-deep .el-tabs__item {
    height: auto !important;
    font-size: 13px;
    color: #4e5969;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #00a551 !important;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #00a551 !important;
  }
  /* 父级页签内容区有左右 20px 内边距，子页签这里复位为 0 */
  ::v-deep .el-tabs__content {
    padding: 0 !important;
    overflow: visible;
  }
}
</style>
